export default "__VITE_ASSET__a0xi1kDd__"